import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowRightIcon, ArrowDownIcon } from 'components/CustomIcons';
import styles from './style.module.less';
export const ExpandIcon = ({ expanded, onExpand, record, expandable, }) => {
    const Icon = expanded ? ArrowDownIcon : ArrowRightIcon;
    return (_jsx("span", { className: styles.expandIconWrapper, children: expandable && (_jsx(Icon, { onClick: (e) => {
                onExpand(record, e);
            } })) }));
};
